import { LegalPage, LegalSection } from './LegalPage';

/**
 * Terms of Service for the Operator platform. Generic B2B SaaS terms — review
 * with counsel and tailor the contact + governing-law details before relying
 * on this for a specific deployment.
 */
export default function TermsPage() {
  return (
    <LegalPage title="Terms of Service" effectiveDate="June 8, 2026">
      <p>
        These Terms of Service ("Terms") govern your access to and use of the
        Operator platform and related services (the "Service"). By accessing or
        using the Service, you agree to be bound by these Terms. If you are
        using the Service on behalf of an organization, you represent that you
        have authority to bind that organization to these Terms.
      </p>

      <LegalSection heading="1. Use of the Service">
        <p>
          The Service lets authorized users design, configure, test, and deploy
          AI agents. You agree to use the Service only for lawful purposes and
          in accordance with these Terms, your organization's policies, and any
          applicable agreement between your organization and us.
        </p>
        <p>
          You are responsible for maintaining the confidentiality of your
          account credentials and for all activity that occurs under your
          account.
        </p>
      </LegalSection>

      <LegalSection heading="2. Accounts and Access">
        <p>
          Access to the Service is provisioned through your organization. Access
          may be suspended or revoked by your organization's administrators or
          by us where required to protect the Service, comply with law, or
          enforce these Terms.
        </p>
      </LegalSection>

      <LegalSection heading="3. Your Content">
        <p>
          You retain ownership of the content, data, and configurations you
          submit to the Service ("Your Content"). You grant us a limited license
          to host, process, and transmit Your Content solely to provide and
          improve the Service. You are responsible for ensuring you have the
          rights necessary to submit Your Content.
        </p>
      </LegalSection>

      <LegalSection heading="4. Acceptable Use">
        <p>You agree not to:</p>
        <ul>
          <li>Use the Service to violate any law or third-party rights;</li>
          <li>
            Attempt to gain unauthorized access to the Service or its related
            systems;
          </li>
          <li>
            Interfere with or disrupt the integrity or performance of the
            Service;
          </li>
          <li>
            Reverse engineer or attempt to extract source code except as
            permitted by law.
          </li>
        </ul>
      </LegalSection>

      <LegalSection heading="5. AI Outputs">
        <p>
          The Service uses AI models that generate outputs based on your inputs
          and configuration. Outputs may be inaccurate or incomplete. You are
          responsible for reviewing outputs before relying on them, and you
          should not use the Service as a substitute for professional advice.
        </p>
      </LegalSection>

      <LegalSection heading="6. Service Availability and Changes">
        <p>
          We may modify, suspend, or discontinue any part of the Service at any
          time. We aim to provide reasonable notice of material changes, but the
          Service is provided on an ongoing basis without a guarantee of
          uninterrupted availability.
        </p>
      </LegalSection>

      <LegalSection heading="7. Disclaimers">
        <p>
          The Service is provided "as is" and "as available" without warranties
          of any kind, whether express or implied, including warranties of
          merchantability, fitness for a particular purpose, and
          non-infringement, to the maximum extent permitted by law.
        </p>
      </LegalSection>

      <LegalSection heading="8. Limitation of Liability">
        <p>
          To the maximum extent permitted by law, we will not be liable for any
          indirect, incidental, special, consequential, or punitive damages, or
          for any loss of profits or data, arising out of or related to your use
          of the Service.
        </p>
      </LegalSection>

      <LegalSection heading="9. Changes to These Terms">
        <p>
          We may update these Terms from time to time. When we do, we will
          revise the effective date above. Your continued use of the Service
          after changes take effect constitutes acceptance of the updated Terms.
        </p>
      </LegalSection>

      <LegalSection heading="10. Contact">
        <p>
          Questions about these Terms should be directed to your organization's
          administrator or to your account contact. See our{' '}
          <a href="/privacy">Privacy Policy</a> for how we handle personal data.
        </p>
      </LegalSection>
    </LegalPage>
  );
}
